
import TableList from '@/components/TableList';
import StatusColumn from '@/views/demand/components/status-column.vue';

export default {
  components: {
    TableList: TableList
  },
  props: {
    config: Object
  },
  data: function data() {
    return {
      tableColumnConfig: [{
        label: '需求ID',
        prop: 'id',
        width: 70
      }, {
        label: '需求名称',
        prop: 'name',
        type: 'link',
        params: {
          tips: function tips(_ref) {
            var row = _ref.row;

            return row.instruction;
          },
          link: function link(_ref2) {
            var row = _ref2.row;

            return '/butler/demand-detail/' + row.id;
          }
        }
      }, {
        label: '设计师',
        prop: 'designer_name'
      }, {
        label: '研发',
        prop: 'developer_name'
      }, {
        label: '状态',
        prop: 'status',
        component: StatusColumn
      }, {
        slot: 'action-cell'
      }]
    };
  },


  methods: {
    isShowTestButton: function isShowTestButton(status) {
      return this.config.status !== 'nopackage' && status === 'dev_ongoing' &&
      // 产品要求：通过代码字实现的需求，不需要展示提测入口。 enable_i18n 等于 1 为通过代码字实现
      this.config.enable_i18n !== 1;
    }
  }
};